<template>
  <DataTable :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable">
    <span slot="after-filters">
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="downloadExcel" flat>
          <v-icon color="primary">far fa-file-excel</v-icon>
        </v-btn>
        <span>Descargar XLS</span>
      </v-tooltip>
    </span>
  </DataTable>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTable
  },

  props: {
    path: {
      type: String,
      default: 'contratos/vencimientos/jugadores/list'
    },
    filterPath: {
      type: String,
      default: 'filters/jugadores/vencimientos'
    },
    excelPath: {
      type: String,
      default: 'contratos/vencimientos/jugadores/xls'
    },
    filenamePrefix: {
      type: String,
      default: 'vencimiento_contratos_jugadores'
    }
  },

  data () {
    return {
      headers: [
        { text: 'Fecha de Fin', value: 'endDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Club', value: 'club', sortable: true, filterField: true },
        { text: 'Apellido', value: 'last_name', sortable: false },
        { text: 'Nombre', value: 'first_name', sortable: false },
        { text: 'Estado', value: 'contractual_status', sortable: false, filterField: true },
        { text: 'Tipo', value: 'contract_types', sortable: false, filterField: true },
        { text: 'Fecha de Inicio', value: 'startDate', sortable: false },
        { text: 'Fecha de Fin', value: 'endDate', sortable: false }
      ],
      properties: ['club', 'playerLastName', 'playerFirstName', 'statusDisplay', 'type', 'startDate', 'endDate'],
      sendEmailAlert: false
    }
  },

  methods: {
    noContracts (item) {
      return (item.verified + item.pending + item.rejected + item.ended) === 0
    },
    getExcelPath () {
      return this.excelPath + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return this.filenamePrefix
    }
  }
}

</script>

<style scoped>
    .table-row {
        background-color: white;
        border-bottom: 1px solid #959ba6;
    }
    .table-row-no-contracts {
        background-color: #d0caca;
        border-bottom: 1px solid #959ba6;
    }
</style>
